import { useQuery } from '@tanstack/react-query';
import { SearchMember } from '#types/member';
import { fetcher } from '../libs';
import queryKeys from '../queryKeys';
import request from '#api/axios';

interface Params {
  name?: string;
}

export const getMembersByCoachName = async (name?: string) => {
  const res = await request<SearchMember[]>({
    method: 'get',
    url: name ? `/members/search?name=${name}` : `/members/search?name`
  });
  return res.data;
};

/**
 * 코치 - 본인 회원 검색 (name이 없는 경우 전체회원 조회)
 * @link https://api-dev.fibud.kr/api#/%ED%9A%8C%EC%9B%90%20%EA%B4%80%EB%A6%AC/MembersController_searchMemberOfCoach
 * @param name
 * @returns
 */
export function useSearchMemberQuery({ name }: Params) {
  return useQuery([queryKeys.MEMBER, name], () =>
    fetcher<SearchMember[]>('/members/search', {
      params: { name }
    })
  );
}
